<template>
  <div class="bbp-reminder-panel-form-date">
    <div class="bbp-reminder-panel-form-date__label">
      Due date
    </div>
    <div class="bbp-reminder-panel-form-date__wrap">
      <BBPDatePicker
        :input="calendarSettings"
        :model="valueObj"
        @input="onChangeDate"
      />
      <div
        v-if="isShowTime"
        class="bbp-reminder-panel-form-date-timer"
      >
        <BBPTimePicker
          :defaultValue="time"
          :model.sync="time"
          :isError.sync="error"
          :inputWidth="'84'"
          :hideDropdown="true"
        />
        <i
          class="bbp-icon-cross bbp-reminder-panel-form-date-timer__cross"
          @click.stop="isShowTime = false"
        />
      </div>
      <div
        v-else
        class="bbp-reminder-panel-form-date-add"
        @click.stop="isShowTime = true"
      >
        <div v-html="plusIcon()"/>
        <div class="bbp-reminder-panel-form-date-add__text">
          Add time
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PLUS_ICON } from '@/constants/icons'
import BBPDatePicker from '@/components/Main/BBPForm/BBPDatePicker/BBPDatePicker'
import BBPTimePicker from '@/components/Main/BBPTimePicker/BBPTimePicker'
import moment from 'moment'

export default {
  name: 'BBPReminderPanelFormDate',
  components: {
    BBPDatePicker,
    BBPTimePicker
  },
  props: {
    valueObj: {
      type: Object,
      default: () => ({})
    },
    defaultBody: {
      type: Object,
      default: () => ({})
    },
    isError: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    calendarSettings: {
      mode: 'single',
      model: 'reminderDate'
    },
    plusIcon: PLUS_ICON,
    isShowTime: false,
    time: moment().format('hh:mm A')
  }),
  computed: {
    error: {
      get () {
        return this.isError
      },
      set (data) {
        this.$emit('update:isError', data)
      }
    }
  },
  methods: {
    onChangeSelect (item) {
      this.valueObj.recur = item
    },
    onChangeDate (value) {
      this.valueObj.reminderDate = value
    },
    setTime () {
      const { reminderDate } = this.valueObj
      const min = moment(reminderDate).minute()
      const h = moment(reminderDate).hour()
      this.time = moment().set('hour', h).set('minute', min).format('hh:mm A')
    },
    showTimePicker () {
      const { _id } = this.defaultBody
      if (!_id) return
      const defTime = moment().set('hour', 8).set('minute', 0).format('hh:mm A')
      this.isShowTime = defTime !== this.time
    }
  },
  watch: {
    time (newTime) {
      this.valueObj.time = newTime
    },
    isShowTime (newVal) {
      if (newVal) {
        this.valueObj.time = this.time
      } else {
        this.valueObj.time = ''
      }
    }
  },
  beforeMount () {
    this.setTime()
    this.showTimePicker()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../sass/variables";

  .bbp-reminder-panel-form-date {

    &__label {
      margin: 0 0 8px 0;
      font-size: 13px;
      line-height: 16px;
      font-weight: 600;
      color: $color-denim;
    }

    &__wrap {
      display: grid;
      grid-template-columns: 119px 1fr;
      align-items: center;
      height: 28px;
    }
  }

  .bbp-reminder-panel-form-date-add {
    display: flex;
    align-items: center;
    cursor: pointer;

    &__text {
      font-size: 13px;
      line-height: 16px;
      font-weight: 500;
      color: $color-denim;
      margin: 0 0 0 5px;
    }

    &:hover {
      opacity: 0.8;
      transition: 0.15s;
    }
  }

  .bbp-reminder-panel-form-date-timer {
    display: grid;
    grid-template-columns: 82px 26px;
    align-items: center;

    &__cross {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 26px;
      height: 29px;
      font-size: 20px;
      color: $color-silver;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
        transition: 0.15s;
      }
    }
  }

</style>

<style lang="scss">

  .bbp-reminder-panel-form-date {

    .bbp-date-picker {
      width: 107px;
    }

    .bbp-date-picker-body {
      padding: 5px 8px !important;
      grid-template-columns: 1fr 17px !important;
    }

    .bbp-time-picker .time-picker input {
      height: 29px !important;
      width: 82px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPReminder/BBPReminderPanel/BBPReminderPanelForm/BBPReminderPanelFormDate.vue